<style lang="scss" scoped>
  #bee-plugin-container {
    top: 150px;
    position: absolute;
    bottom: 0;
    left: 20px;
    right: 20px;
    padding-top: 1.5rem;
    margin-bottom: 3rem;
    box-shadow: 0 5px 20px rgba(165, 131, 224, 0.15);
  }

  .top-bar-left span.main-logo {
    display: none !important;
  }
</style>

<template>
  <section class="mail-bee">
    <div class="row">
      <div class="col-12 d-flex align-items-center">
        <h2 class="page-subtitle">
          {{ mail.title || __('Modelo sem título') }}
        </h2>
        <MailAction
          class="ml-auto"
          :user="user"
          :mail="mail"
        />
      </div>
    </div>
    <MailConfig
      :user="user"
      :mail="mail"
    />
    <div id="bee-plugin-container" />
    <div id="integrator-bottom-bar" />
    <MailSend
      :user="user"
      :id="mail.id"
    />
    <BModal
      id="save-template-modal"
      ref="save-template-modal"
      hide-footer="hide-footer"
      modal-class="modal-width-340"
    >
      <template slot="modal-title">
        {{ __('Salvar e-mail como template') }}
      </template>
      <template slot="default">
        <form
          class="form"
          method="post"
        >
          <div class="form-group">
            <label>{{ __('Título') }}</label>
            <input
              class="form-control"
              type="text"
              required=""
              v-model="template.title"
            >
          </div>
          <div class="modal-footer default-modal-footer">
            <button
              class="btn btn-box"
              type="submit"
              @click.prevent="saveAsTemplate"
              :disabled="template.saving"
            >
              <span v-if="! template.saving">{{ __('Salvar') }}</span><span v-else><i class="fa fa-circle-o-notch fa-spin mr-1" /> {{ __('Salvando...') }}</span>
            </button>
          </div>
        </form>
      </template>
    </BModal>
  </section>
</template>

<script>
import { BModal } from 'bootstrap-vue';
import Swal from 'sweetalert2';

const invoiceVars = [
  {
    name: 'Primeiro Nome da Empresa',
    value: '{{ company_first_name }}'
  },
  {
    name: 'ID da fatura',
    value: '{{ invoice_id }}',
  },
  {
    name: 'URL da fatura',
    value: '{{ invoice_url }}',
  },
  {
    name: 'Valor total da fatura',
    value: '{{ invoice_total }}',
  },
  {
    name: 'Status da fatura',
    value: '{{ invoice_status }}',
  },
  {
    name: 'Descrição da fatura',
    value: '{{ invoice_status_description }}',
  },
  {
    name: 'Código de Barras do Boleto',
    value: '{{ invoice_digitable_line }}',
  },
];

export default {
  components: {
    BModal,
  },

  props: ['user', 'mail', 'fields'],

  created () {
    this.loadBee();

    const beforeunload = (event) => {
      if(this.isDirty) {
        const message = 'Seu conteúdo não está salvo. Deseja realmente sair do editor?';
        event.returnValue = message;
        return message;
      }
    }
    
    window.onbeforeunload = beforeunload;
    // window.addEventListener('beforeunload', beforeunload);
  },

  beforeDestroy() {
    window.removeEventListener('beforeunload', this.beforeunload);
  },

  mounted () {
    this.config();
  },

  computed: {
    mailUrl () {
      return `/mail/${this.mail.id}`;
    },
  },

  data () {
    return {
      // mail: {},
      bee: {},
      template: {
        saving: false,
        title: '',
        json: {},
      },
      ready: false,
      testing: false,
      isDirty: false,
      loading: false,
    };
  },

  methods: {
    loadBee () {
      ! (function (e) { if (! window.BeePlugin) { const t = function () { const e = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'; return Array.apply(null, Array(50)).map(() => e[Math.floor(Math.random() * e.length)]).join(''); }; const n = e.createElement('script'); n.type = 'text/javascript', n.src = `https://loader.getbee.io/v1/api/loader?v=${t()}`, e.getElementsByTagName('head')[0].appendChild(n); const r = {}; r._queue = []; for (let a = 'create'.split(','), u = function (e, t) { return function () { t.push([e, arguments]); }; }, i = 0; i < a.length; i++)r[a[i]] = u(a[i], r._queue); window.BeePlugin = r; } }(document));
    },

    hasLocalStorage () {
      const autosave = JSON.parse(window.localStorage.getItem(`mail.autosave.${this.mail.id}`));

      return autosave && autosave.json;
    },

    cleanupLocalStorage () {
      window.localStorage.setItem(`mail.autosave.${this.mail.id}`, '{}');
    },

    clear () {
      // TODO: cleanup storage on unload and remove button to clean it
      this.cleanupLocalStorage();
      this.bee.load(this.mail.json);
    },

    truncate (str, length = 50) {
      return `${str.substring(0, length).trim()}...`;
    },

    config () {
      const specialLinks = [{
        type: 'Feed',
        label: 'Unsubscribe',
        link: '{{ unsubscribe_url }}',
      }, {
        type: 'Feed',
        label: 'Visualizar na web',
        link: '{{ webview_url }}',
      }];

      const mergeTags = this.fields.map((field) => {
        field.name = this.truncate(field.name);
        field.value = `{{ ${field.value} }}`;

        return field;
      });

      const mergeContents = [{
        name: 'Assinatura do usuário',
        value: '{{{ user_signature }}}',
      }];

      const self = this;

      const beeConfig = {
        uid: `bee-${this.user.account}`,
        container: 'bee-plugin-container',
        autosave: 30,
        language: 'pt-BR',
        specialLinks,
        mergeTags: [...mergeTags, ...invoiceVars],
        mergeContents,
        trackChanges: true,
        onSave (jsonFile, htmlFile) {
          self.save({ json: jsonFile, html: htmlFile }).then(() => {
            console.log('bsaved');
            if (self.loading) {
              self.loading = false;
            } else if (! self.testing) {
              self.showSendQuestion();
            }
            self.testing = false;
          });
          self.localSave(jsonFile);
          self.isDirty = false;
        },
        onChange: function(jsonFile, response) {
          self.isDirty = true;
        },
        onSaveAsTemplate (jsonFile) { // + thumbnail?
          self.localSave(jsonFile);

          self.openSaveAsTemplateModal(jsonFile);
        },
        onAutoSave (jsonFile) { // + thumbnail?
          console.log(`${new Date().toISOString()}- autosaving...`);

          self.localSave(jsonFile);
        },
        onSend: ((htmlFile) => {
          Alert.error(this.__('A funcionalidade de envio de e-mail de teste foi desabilitada'));
        }).bind(this),
        onLoad () {
          if (! self.mail.html) {
            self.loading = true;
            self.bee.save();
          }
        },
        onError (errorMessage) {
          console.log('onError ', errorMessage);
        },
      };

      this.$http.post('/integration/bee')
        .then(({ data }) => {
          BeePlugin.create(data, beeConfig, (bee) => {
            const autosave = JSON.parse(window.localStorage.getItem(`mail.autosave.${this.mail.id}`));

            const { json } = this.mail;

            // if (autosave && autosave.json && moment(autosave.date || 0).isAfter(this.mail.updated_at)) {
            //   json = JSON.parse(autosave.json);
            // }

            this.bee = bee;
            this.bee.start(this.mail.json);

            setTimeout(() => this.ready = true, 300);
          });
        });
    },

    localSave (jsonFile) {
      const autosave = {
        date: Date.now(),
        json: jsonFile,
      };

      window.localStorage.setItem(`mail.autosave.${this.mail.id}`, JSON.stringify(autosave));
    },

    openSaveAsTemplateModal (jsonFile) {
      this.template.jsonFile = JSON.parse(jsonFile);

      this.$refs['save-template-modal'].show();
    },

    saveAsTemplate () {
      this.template.saving = true;

      this.$http.post('/mail/template', {
        json: this.template.jsonFile,
        title: this.template.title,
      })
        .then(() => {
          Alert.success(this.__('Modelo de e-mail salvo como template.'));
        })
        .catch((response) => {
          console.log(response);

          Alert.error(this.__('Ops, não foi possível criar o template.'));
        })
        .finally(() => {
          this.template.title = '';
          this.template.saving = false;

          this.$refs['save-template-modal'].hide();
        });
    },

    save (data) {
      data.json = JSON.parse(data.json);

      return this.$http.put(`/mail/${this.mail.id}`, data)
        .then(() => {
          // Alert.success('Conteúdo salvo.');

          this.cleanupLocalStorage();

          if (this.testing) {
            Bus.$emit('sendMailModal');
          }
        })
        .catch(({ data }) => {
          Alert.error(data.error);
        });
    },

    send () {
      this.$http.get(`/automation/mail/${this.mail.id}`)
        .then(({ data }) => {
          window.location = `/automation/${data.id}#sending`;
        })
        .catch(() => {
          console.warn('Não foi possivel enviar o email!');
          Alert.error(this.__('Não foi possivel enviar o email!'));
        });
    },

    showSendQuestion () {
      Swal.fire({
        icon: 'success',
        title: this.__('Seu conteúdo foi salvo!'),
        text: this.__('Deseja enviar este e-mail agora?'),
        width: 350,
        buttonsStyling: false,
        allowEscapeKey: false,
        allowOutsideClick: false,
        confirmButtonText: this.__('Enviar agora'),
        cancelButtonColor: 'transparent',
        cancelButtonText: this.__('Salvar para enviar mais tarde'),
        showCancelButton: true,
        customClass: {
          container: 'container-swal2',
          confirmButton: 'btn btn-primary ',
          cancelButton: 'btn swal2-btn-cancel-transparent swal2-btn-full-line',
        },
      }).then((result) => {
        if (result.dismiss !== 'cancel') {
          this.send();
        }
      });
    },

  },
};
</script>
